/**
 * Translate pool_config (payout_mode + payout_split + end_of_league_prize_pence)
 * into a list of {rank, label, pence, pct} slices for display.
 *
 * Backed by /app/backend/core/payouts.py (single source of truth on the server).
 * The frontend mirrors that split logic so the banners and emails agree.
 */
export function prizeSplitSlices(pool) {
  if (!pool) return [];
  const total = Number(pool.end_of_league_prize_pence || 0);
  if (total <= 0) return [];

  const mode = (pool.payout_mode || "winner_all").trim();
  let ranked = [];
  if (mode === "custom") {
    const s = pool.payout_split || {};
    for (const [rank, key] of [[1, "first"], [2, "second"], [3, "third"]]) {
      const pct = Number(s?.[key] || 0);
      if (pct > 0) ranked.push([rank, pct]);
    }
  } else if (mode === "50_30_20") {
    ranked = [[1, 50], [2, 30], [3, 20]];
  } else {
    ranked = [[1, 100]];
  }

  const rankSuffix = (n) => (["st", "nd", "rd"][n - 1] || "th");
  return ranked.map(([rank, pct]) => ({
    rank,
    label: `${rank}${rankSuffix(rank)}`,
    pct,
    pence: Math.round((total * pct) / 100),
  }));
}

export function formatPounds(pence) {
  if (!pence) return "£0.00";
  return `£${(Number(pence) / 100).toFixed(2)}`;
}
